<template>
  <div>
    <Head title="Carboidratos" />
    <div class="shadow_box rounded-lg p-6">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Dicas de saúde</h1>
      <data-table
        v-if="loadTable"
        v-model:columns="columns"
        route="health-tips/list"
        no-data-label="Nenhuma dica de saúde cadastrada"
        no-result-label="Nenhuma dica de saúde encontrada"
      >
        <template #table.cell.content.health_tip_link="{ value, row }">
          <a v-if="row.type == 'youtube'" :href="row.link" target="_blank">{{ row.link }}</a>
          <img v-if="row.type == 'image'" :src="'/uploads/tips/' + row.image" style="max-width: 150px; max-height: 100px">
        </template>
        <template #grid.content.body.health_tip_link="{ value, row }">
          <a v-if="row.type == 'youtube'" :href="row.link" target="_blank">{{ row.link }}</a>
          <img v-if="row.type == 'image'" :src="'/uploads/tips/' + row.image" style="max-width: 150px; max-height: 100px">
        </template>
        <template #table.cell.content.actions="{ value, row }">
            <div class="inline-grid grid-cols-2 gap-4 ">
                <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-blue-500 text-lg cursor-pointer" /></span>
                <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
            </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
            <div class="inline-grid grid-cols-2 gap-4 ">
                <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-blue-500 text-lg cursor-pointer" /></span>
                <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
            </div>
        </template>
    
        <template #after.reload-button>
            <button class="flex items-end font-roboto font-medium btn-blue uppercase" @click.prevent="openModalEdit({})">
            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span class="hidden lg:block"> Adicionar Dica</span>
            </button>
        </template>
      </data-table>
    </div>
    <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
    <modal-edit ref="modalEdit" :multipart="true" title="Dica" url="health-tips" @submitForm="reloadTable">
      <template #form="{item}">
        <text-input v-model="item.title" :error="item.errors.title" class="lg:pr-6 w-full lg:w-1/2" label="Título" />
        <select-input v-model="item.type" :error="item.errors.type" class="mt-6 lg:mt-0 w-full lg:w-1/2" label="Tipo de dica">
          <option :value="null" />
          <option v-for="(value, name, index) in tip_types" :key="name" :value="name">{{ value }}</option>
        </select-input>
        <date-input v-model="item.date_start" :error="item.errors.date_start" class="mt-6 lg:pr-6 w-full lg:w-1/2" label="Data de Início" />
        <date-input v-model="item.date_end" :error="item.errors.date_end" class="mt-6 w-full lg:w-1/2" label="Data Final" />
        <textarea-input v-model="item.description" :error="item.errors.description" class="mt-6 w-full" label="Descrição" />
        <text-input v-model="item.link" v-if="item.type == 'youtube'" :error="item.errors.link" class="mt-6 w-full" label="Link do Youtube" />
        <file-input v-model="item.image" v-if="item.type == 'image'" :error="item.errors.image" class="mt-6 w-full" type="file" accept="image/*" label="Imagem" />
      </template>
    </modal-edit>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import SwitchInput from '@/Shared/SwitchInput'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import TextareaInput from '@/Shared/TextareaInput'
import DataTable from '@/Shared/DataTable'
import DateInput from '@/Shared/DateInput'

export default {
  props: {
    tip_types: Object,
  },
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    SwitchInput,
    TextInput,
    TextareaInput,
    SelectInput,
    DataTable,
    FileInput,
    DateInput,
  },
  layout: Layout,
  data() {
    return {
      loadTable: true,
      columns: [
        {
          uniqid: 'health_tip_title',
          label: 'Título',
          field: 'title',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'health_tip_description',
          label: 'Descrição',
          field: 'description',
          visible: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm overflow-hidden',
          headerClass: 'p-4 text-left',
          format: (val, row) => val ? val.substr(0, 50) : ''
        },
        {
          uniqid: 'health_tip_type',
          label: 'Tipo de dica',
          field: 'type',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.type_label
        },
        {
          uniqid: 'health_tip_link',
          label: 'Conteúdo',
          field: 'link',
          visible: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm overflow-hidden',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  methods: {
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/health-tips/${item.id}`, `Deseja realmente excluir a dica de saúde ${item.title}?`);
    },
    openModalEdit(item) {
      this.$refs.modalEdit.openModalEdit({
        id: item.id,
        title: item.title,
        type: item.type,
        link: item.link,
        image: '',
        description: item.description,
        date_start: item.date_start,
        date_end: item.date_end,
        errors: {}
      });
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    }
  },
}
</script>